const TMF_LOGO = "/tmf-logo-full.png";

export function Logo({ className = "" }) {
  return (
    <div className={`flex items-center ${className}`} data-testid="tmf-logo">
      <div className="rounded-lg bg-white px-2 py-1 shadow-sm flex items-center justify-center overflow-hidden">
        <img
          src={TMF_LOGO}
          alt="Text Me Food — Food Support Made Easy"
          className="h-10 md:h-12 w-auto object-contain"
        />
      </div>
    </div>
  );
}
